import React, { useMemo } from "react";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faLink } from "@fortawesome/free-solid-svg-icons";
import TSUtils from "../../../../utils/helpers/TSUtils";
import { tt } from "../../../../utils/i18n/i18n";
import KC_Button, {
  KC_ButtonSize
} from "../../../../designsystem/KC_Button/KC_Button";
import KC_Text from "../../../../designsystem/typography/KC_Text/KC_Text";
import { KC_Text_Sizes, KC_Weights } from "../../../../designsystem/ds_commons";
import { useJetpackConfigSelector } from "../../../../redux/jetpackConfig";
import { useCustomPOSASelector } from "../../../../redux/customPOSA";
import { BASE_URL } from "../../../../utils/constants";
import POSAPreviewCard from "./POSAPreviewCard";
import { POSAMode } from "../POSAEditor/model";
import Carousel from "../../../../components/Carousel/Carousel";
import { usePOSATypesSelector } from "../../../../redux/actions/wheel";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";
import TwemojiWrapper from "../../../../components/TwemojiWrapper/TwemojiWrapper";
import KC_Heading1 from "../../../../designsystem/typography/KC-Heading/KC_Heading1";

export default function OnlinePOSAGallery() {
  const { accountToDisplay } = useAccountToDisplaySelector();
  const jetpackConfig = useJetpackConfigSelector();
  const customPOSAs = useCustomPOSASelector();
  const posas = usePOSATypesSelector();

  const POSA_ONLINE_ARRAY = useMemo(() => {
    return posas.filter((p) => p.isOnline);
  }, [posas]);

  const gameLink = useMemo(() => {
    if (jetpackConfig == null || !jetpackConfig.configId) return "";
    return TSUtils.createJPGameLink(jetpackConfig.configId, true);
  }, [accountToDisplay]);

  const SLIDES = useMemo(() => {
    return POSA_ONLINE_ARRAY.map((posa) => {
      const customPOSA = customPOSAs.find((p) => p.posaTypeId === posa._id);
      if (customPOSA) {
        return (
          <React.Fragment key={customPOSA._id}>
            <POSAPreviewCard
              posa={posa}
              posaMode={POSAMode.Online}
              eventId={"default"}
              handleSelected={() => {}}
              customPOSA={customPOSA}
              bordered={true}
              description={
                posa.format === "online-ig-story"
                  ? tt("online_posa_ig_story")
                  : tt("online_posa_ig_post")
              }
            />
          </React.Fragment>
        );
      }

      return (
        <POSAPreviewCard
          posa={posa}
          posaMode={POSAMode.Online}
          eventId={"default_2"}
          handleSelected={() => {}}
          description={
            posa.format === "online-ig-story"
              ? tt("online_posa_ig_story")
              : tt("online_posa_ig_post")
          }
          bordered={true}
        />
      );
    });
  }, [POSA_ONLINE_ARRAY, customPOSAs]);

  return (
    <div className="d-flex flex-column st-gap p-4">
      <TwemojiWrapper className="twemoji-h1">
        <KC_Heading1 text={tt("online_posa_gallery_title")} className="mb-2" />
      </TwemojiWrapper>

      <div
        className="p-4 d-flex flex-column st-gap"
        style={{ border: "1px solid rgba(0, 0, 0, 0.10)", borderRadius: 16 }}
      >
        <div className="d-flex w-100 align-items-center gap-sm">
          <FontAwesomeIcon icon={faLink} />
          <KC_Heading3 text={tt("online_posa_copy_link")} />
        </div>
        <div className="d-flex flex-column flex-sm-row align-items-center gap-sm">
          <div className="kc-input-wrapper">
            <input className="kc_input pl-2" value={gameLink} />
          </div>
          <KC_Button
            isPrimary={true}
            size={KC_ButtonSize.Large}
            showIconOnTheLeft={true}
            icon={faCopy}
            text={tt("copy_link")}
            className="w-100 d-flex copy-link-btn"
          />
        </div>
      </div>
      <div
        className="p-4 d-flex flex-column st-gap"
        style={{
          border: "1px solid rgba(0, 0, 0, 0.10)",
          borderRadius: 16,
          overflow: "hidden"
        }}
      >
        <div
          className="border-bottom mx-4 d-flex flex-column st-gap"
          style={{ paddingBottom: 16 }}
        >
          <KC_Heading3 text={tt("online_posa_templates_heading")} />
          <div
            className="d-flex gap-lg"
            style={{ overflow: "scroll", scrollbarWidth: "none" }}
          >
            <div style={{ width: 227 }}>
              <img
                alt={"illustration-img-template"}
                src={`${BASE_URL}/img/misc/posaOnlineStep1.png`}
              />
              <KC_Text
                className="d-block mt-2"
                size={KC_Text_Sizes.lg}
                text={tt("onlinePOSAGallery_template_step1")}
                weight={KC_Weights.reg}
              />
            </div>
            <div style={{ width: 227 }}>
              <img
                alt={"illustration-story-insta"}
                src={`${BASE_URL}/img/misc/posaOnlineStep2.png`}
              />
              <KC_Text
                className="d-block mt-2"
                size={KC_Text_Sizes.lg}
                text={tt("onlinePOSAGallery_template_step2")}
                weight={KC_Weights.reg}
              />
            </div>
            <div style={{ width: 227 }}>
              <img
                alt={"illustration-add-link"}
                src={`${BASE_URL}/img/misc/posaOnlineStep3.png`}
              />
              <KC_Text
                className="d-block mt-2"
                size={KC_Text_Sizes.lg}
                text={tt("onlinePOSAGallery_template_step3")}
                weight={KC_Weights.reg}
              />
            </div>
            <div style={{ width: 227 }}>
              <div className="w-100">
                <img
                  alt={"illustration-upload-story"}
                  src={`${BASE_URL}/img/misc/posaOnlineStep4.png`}
                />
              </div>
              <KC_Text
                className="d-block mt-2"
                size={KC_Text_Sizes.lg}
                text={tt("onlinePOSAGallery_template_step4")}
                weight={KC_Weights.reg}
              />
            </div>
          </div>
        </div>
        <Carousel
          id="online-posa-carousel"
          slides={SLIDES}
          baseId="online-posa-carousel"
          style={{
            height: 670
          }}
        />
      </div>
    </div>
  );
}
